var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-731.000000, -707.000000)",
    stroke: "#A17D58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(512.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,35.483871 C50,43.5008065 43.5008065,50 35.483871,50 C27.4669355,50 20.9677419,43.5008065 20.9677419,35.483871 C20.9677419,27.4669355 27.4669355,20.9677419 35.483871,20.9677419 C43.5008065,20.9677419 50,27.4669355 50,35.483871 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4516129,39.9193548 C32.4596774,41.9354839 34.4758065,41.9354839 34.4758065,41.9354839 L36.5830645,41.9354839 C38.1959677,41.9354839 39.516129,40.6153226 39.516129,39.0024194 L39.516129,38.3064516 C39.516129,36.7540323 38.2459677,35.483871 36.6935484,35.483871 L34.2741935,35.483871 C32.7217742,35.483871 31.4516129,34.2137097 31.4516129,32.6612903 C31.4516129,31.108871 32.7217742,29.8387097 34.2741935,29.8387097 L36.4919355,29.8387097 C36.4919355,29.8387097 38.5080645,29.8387097 39.516129,31.8548387",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.483871,27.4193548 L35.483871,29.8387097",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.483871,41.9354839 L35.483871,43.5483871",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    points: "20.9677419 12.0967742 20.9677419 20.9677419 9.67741935 20.9677419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.576371,17.1174194 C39.7675,7.37709677 31.2320161,-0.000322580645 20.9675,-0.000322580645 C9.38766129,-0.000322580645 -0.000241935484,9.38758065 -0.000241935484,20.9674194 C-0.000241935484,31.2319355 7.37717742,39.7674194 17.1175,41.5762903",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3643548,16.1510484 C34.3159677,9.59620968 28.1974194,4.83895161 20.9675806,4.83895161 C12.0595161,4.83895161 4.83854839,12.0599194 4.83854839,20.9679839 C4.83854839,28.1978226 9.5966129,34.3155645 16.1514516,36.3639516",
    id: "Stroke-13"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon4);
export default __webpack_public_path__ + "static/media/product-icon4.f6721c216340441621e4c9ad11d0b5ca.svg";
export { ForwardRef as ReactComponent };